export default "__VITE_ASSET__BtxjqX0K__"